
import React from 'react';
import {
    Box,
    RoutedButton,
    Grid,
    Heading,
    Paragraph,
    ResponsiveContext,
    Text
} from 'grommet';

import { getAppName, getVersionString } from '../utils';

const BACKGROUND_URL = 'assets/background.jpg';
const BACKGROUND_STYLES = {
    background: `linear-gradient(rgba(0,0,0,0.0),rgba(0,0,0,0.0)),url("${BACKGROUND_URL}") center no-repeat`,
    backgroundSize: 'cover'
};

const DESCRIPTION_1 = `
Software je výsledkem projektu NAKI II: „Vinohradnictví a vinařství pro zachování a obnovu kulturní identity vinařských regionů na Moravě“.
`;
const DESCRIPTION_2 = `
Číslo projektu: DG16P02R017
`;
const DESCRIPTION_3 = `
Aplikace přináší informace o viničních tratích a odrůdách révy významných vinařských obcí na Moravě.
`;
const DESCRIPTION_4 = `
Vyhledat můžete: Biotické mapování lokalit, Geologicko-pedologické mapování, Současné a historické viniční tratě, Odrůdová skladba na tratích, Genetické analýzy odrůd, Vinařské stavby
`;

const Title = () => {
    return (
        <Heading level={1} size="large" color="light-1" textAlign="center" >
            {getAppName()}
        </Heading>
    );
}

const Description = () => {
    return (
        <Box align="center">
            <Paragraph size="large" color="light-3" textAlign="center" style={{textShadow: '1px 1px black, -1px 1px black, -1px -1px black, 1px -1px black'}}>
                {DESCRIPTION_1}
            </Paragraph>
            <Paragraph size="large" color="light-3" textAlign="center" style={{textShadow: '1px 1px black, -1px 1px black, -1px -1px black, 1px -1px black'}}>
                {DESCRIPTION_2}
            </Paragraph>
            <Paragraph color="light-3" textAlign="center" style={{textShadow: '1px 1px black, -1px 1px black, -1px -1px black, 1px -1px black'}}>
                {DESCRIPTION_3}
                </Paragraph>
            <Paragraph color="light-3" textAlign="center" style={{textShadow: '1px 1px black, -1px 1px black, -1px -1px black, 1px -1px black'}}>
                {DESCRIPTION_4}
            </Paragraph>
        </Box>
    );
}

const ButtonLink = ({path, title}) => {
    return (
        <Box>
            <RoutedButton plain={true} path={path}>
                <Box align="center" background="brand" pad="16px" width="260px">
                    <Heading size="small">{title}</Heading>
                </Box>
            </RoutedButton>
        </Box>
    );
}

const ButtonLinkSmall = ({path, title}) => {
    return (
        <Box>
            <RoutedButton plain={true} path={path}>
                <Box align="center" background="brand" pad="4px" width="300px">
                    <Text size="large" margin="xsmall">{title}</Text>
                </Box>
            </RoutedButton>
        </Box>
    );
}

const ButtonShowAbout = () => {
    return (
        <ButtonLinkSmall path="/link_o_aplikaci" title="O aplikaci" />
    );
}

const ButtonShowAutor = () => {
    return (
        <ButtonLinkSmall path="/autor" title="Autorský kolektiv" />
    );
}

const ButtonShowMap = () => {
    return (
        <ButtonLink path="/map" title="Mapa" />
    );
}

const ButtonShowTrate = () => {
    return (
        <ButtonLink path="/trate" title="Seznam tratí" />
    );
}

const ButtonShowOdrudy = () => {
    return (
        <ButtonLink path="/odrudy" title="Seznam odrůd" />
    );
}

const Version = () => {
    return (
        <Text size="xsmall" color="dark-4">
            Verze {getVersionString()}
        </Text>
    );
}

const HomePageLarge = (props) => {
    return (
        <Grid fill style={BACKGROUND_STYLES} >
            <Box direction="column">
                <Box flex="grow" justify="center" align="center">
                    <Title />
                    <Description />
                </Box>
                <Box justify="center" align="center" gap="large" pad="24px" direction="row">
                    <ButtonShowTrate />
                    <ButtonShowOdrudy />
                    <ButtonShowMap />
                </Box>
                <Box justify="center" align="center" gap="large" pad="24px" direction="row">
                    <ButtonShowAutor />
                    <ButtonShowAbout />
                </Box>
                <Version />
            </Box>
        </Grid>
    );
}

const HomePageMedium = (props) => {
    return (
        <Box style={BACKGROUND_STYLES} flex="grow" pad="small" fill>
            <Box align="center" flex="grow" gap="medium" >
                <Title />
                <Description />
                <Box>
                    <Box justify="center" align="center" gap="large" pad="24px" direction="row">
                        <ButtonShowTrate />
                        <ButtonShowOdrudy />
                        <ButtonShowMap />
                    </Box>
                    <Box justify="center" align="center" gap="large" pad="24px" direction="row">
                        <ButtonShowAutor />
                        <ButtonShowAbout />
                    </Box>
                </Box>
            </Box>
            <Box>
                <Version />
            </Box>
        </Box>
    );
}

const HomePageSmall = (props) => {
    return (
        <Box style={BACKGROUND_STYLES} flex="grow" pad="small" fill>
            <Box align="center" flex="grow" gap="small" >
                <Title />
                <Description />
                <ButtonShowTrate />
                <ButtonShowOdrudy />
                <ButtonShowAutor />
                <ButtonShowAbout />
            </Box>
            <Box>
                <Version />
            </Box>
        </Box>
    );
}

const HomePage = (props) => {
    return (
        <ResponsiveContext.Consumer>
            {(size) => {
                switch (size) {
                    case 'large':
                        return <HomePageLarge {...props} />
                    case 'medium':
                        return <HomePageMedium {...props} />
                    default:
                        return <HomePageSmall {...props} />
                }
            }}
        </ResponsiveContext.Consumer>
    );
}

export default HomePage;
